var city =
{
    "citycode": [],
    "adcode": "440000",
    "name": "广东省",
    "center": {
        "lng": 113.266887,
        "lat": 23.133306
    },
    "districtList": [
        {
            "citycode": "020",
            "adcode": "440100",
            "name": "广州",
            "center": {
                "lng": 113.264499,
                "lat": 23.130061
            },
            "districtList": [
                {
                    "citycode": "020",
                    "adcode": "440105",
                    "name": "海珠区",
                    "center": {
                        "lng": 113.317412,
                        "lat": 23.084003
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440114",
                    "name": "花都区",
                    "center": {
                        "lng": 113.220125,
                        "lat": 23.404326
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440117",
                    "name": "从化区",
                    "center": {
                        "lng": 113.586329,
                        "lat": 23.54915
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440112",
                    "name": "黄埔区",
                    "center": {
                        "lng": 113.480613,
                        "lat": 23.181355
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440113",
                    "name": "番禺区",
                    "center": {
                        "lng": 113.383917,
                        "lat": 22.93756
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440106",
                    "name": "天河区",
                    "center": {
                        "lng": 113.361597,
                        "lat": 23.124817
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440103",
                    "name": "荔湾区",
                    "center": {
                        "lng": 113.218998,
                        "lat": 23.107123
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440111",
                    "name": "白云区",
                    "center": {
                        "lng": 113.2732,
                        "lat": 23.157159
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440104",
                    "name": "越秀区",
                    "center": {
                        "lng": 113.267065,
                        "lat": 23.128673
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440115",
                    "name": "南沙区",
                    "center": {
                        "lng": 113.525178,
                        "lat": 22.801435
                    }
                },
                {
                    "citycode": "020",
                    "adcode": "440118",
                    "name": "增城区",
                    "center": {
                        "lng": 113.810734,
                        "lat": 23.261452
                    }
                }
            ]
        },
        {
            "citycode": "0755",
            "adcode": "440300",
            "name": "深圳",
            "center": {
                "lng": 114.057939,
                "lat": 22.543527
            },
            "districtList": [
                {
                    "citycode": "0755",
                    "adcode": "440306",
                    "name": "宝安区",
                    "center": {
                        "lng": 113.883831,
                        "lat": 22.554986
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440305",
                    "name": "南山区",
                    "center": {
                        "lng": 113.930478,
                        "lat": 22.533191
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440304",
                    "name": "福田区",
                    "center": {
                        "lng": 114.055198,
                        "lat": 22.520922
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440307",
                    "name": "龙岗区",
                    "center": {
                        "lng": 114.246884,
                        "lat": 22.720889
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440311",
                    "name": "光明区",
                    "center": {
                        "lng": 113.936059,
                        "lat": 22.74875
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440308",
                    "name": "盐田区",
                    "center": {
                        "lng": 114.236739,
                        "lat": 22.557001
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440303",
                    "name": "罗湖区",
                    "center": {
                        "lng": 114.131611,
                        "lat": 22.548309
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440309",
                    "name": "龙华区",
                    "center": {
                        "lng": 114.04491,
                        "lat": 22.696735
                    }
                },
                {
                    "citycode": "0755",
                    "adcode": "440310",
                    "name": "坪山区",
                    "center": {
                        "lng": 114.350844,
                        "lat": 22.708786
                    }
                }
            ]
        },
        {
            "citycode": "0769",
            "adcode": "441900",
            "name": "东莞",
            "center": {
                "lng": 113.751884,
                "lat": 23.021016
            },
            "districtList": [
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "黄江镇",
                    "center": {
                        "lng": 113.983316,
                        "lat": 22.883915
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "清溪镇",
                    "center": {
                        "lng": 114.109028,
                        "lat": 22.864049
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "桥头镇",
                    "center": {
                        "lng": 114.065029,
                        "lat": 23.031536
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "洪梅镇",
                    "center": {
                        "lng": 113.606888,
                        "lat": 23.015507
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "高埗镇",
                    "center": {
                        "lng": 113.77292,
                        "lat": 23.100117
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "麻涌镇",
                    "center": {
                        "lng": 113.616702,
                        "lat": 23.088653
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "塘厦镇",
                    "center": {
                        "lng": 114.057782,
                        "lat": 22.833564
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "望牛墩镇",
                    "center": {
                        "lng": 113.675238,
                        "lat": 23.067562
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "万江街道",
                    "center": {
                        "lng": 113.714249,
                        "lat": 23.004871
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "道滘镇",
                    "center": {
                        "lng": 113.687246,
                        "lat": 23.004094
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "莞城街道",
                    "center": {
                        "lng": 113.756157,
                        "lat": 23.026359
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "东坑镇",
                    "center": {
                        "lng": 113.921005,
                        "lat": 22.989113
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "大岭山镇",
                    "center": {
                        "lng": 113.806239,
                        "lat": 22.948285
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "谢岗镇",
                    "center": {
                        "lng": 114.171775,
                        "lat": 22.984642
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "南城街道",
                    "center": {
                        "lng": 113.768809,
                        "lat": 22.941355
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "东城街道",
                    "center": {
                        "lng": 113.77206,
                        "lat": 22.941938
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "企石镇",
                    "center": {
                        "lng": 113.989933,
                        "lat": 23.054588
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "樟木头镇",
                    "center": {
                        "lng": 114.015449,
                        "lat": 22.86927
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "常平镇",
                    "center": {
                        "lng": 114.041069,
                        "lat": 23.007892
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "凤岗镇",
                    "center": {
                        "lng": 114.139781,
                        "lat": 22.777948
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "寮步镇",
                    "center": {
                        "lng": 113.917593,
                        "lat": 22.981271
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "沙田镇",
                    "center": {
                        "lng": 113.582201,
                        "lat": 22.942601
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "横沥镇",
                    "center": {
                        "lng": 114.03027,
                        "lat": 23.035086
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "茶山镇",
                    "center": {
                        "lng": 113.840966,
                        "lat": 23.09276
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "大朗镇",
                    "center": {
                        "lng": 113.947048,
                        "lat": 22.865074
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "石排镇",
                    "center": {
                        "lng": 113.989827,
                        "lat": 23.069114
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "中堂镇",
                    "center": {
                        "lng": 113.612748,
                        "lat": 23.042585
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "长安镇",
                    "center": {
                        "lng": 113.802243,
                        "lat": 22.838519
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "厚街镇",
                    "center": {
                        "lng": 113.631616,
                        "lat": 22.934094
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "虎门镇",
                    "center": {
                        "lng": 113.631506,
                        "lat": 22.832134
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "石龙镇",
                    "center": {
                        "lng": 113.859745,
                        "lat": 23.087788
                    }
                },
                {
                    "citycode": "0769",
                    "adcode": "441900",
                    "name": "石碣镇",
                    "center": {
                        "lng": 113.772148,
                        "lat": 23.095617
                    }
                }
            ]
        },
        {
            "citycode": "0752",
            "adcode": "441300",
            "name": "惠州",
            "center": {
                "lng": 114.415587,
                "lat": 23.112368
            },
            "districtList": [
                {
                    "citycode": "0752",
                    "adcode": "441324",
                    "name": "龙门县",
                    "center": {
                        "lng": 114.254898,
                        "lat": 23.727873
                    }
                },
                {
                    "citycode": "0752",
                    "adcode": "441323",
                    "name": "惠东县",
                    "center": {
                        "lng": 114.720136,
                        "lat": 22.984831
                    }
                },
                {
                    "citycode": "0752",
                    "adcode": "441303",
                    "name": "惠阳区",
                    "center": {
                        "lng": 114.456107,
                        "lat": 22.789431
                    }
                },
                {
                    "citycode": "0752",
                    "adcode": "441302",
                    "name": "惠城区",
                    "center": {
                        "lng": 114.382526,
                        "lat": 23.084657
                    }
                },
                {
                    "citycode": "0752",
                    "adcode": "441322",
                    "name": "博罗县",
                    "center": {
                        "lng": 114.289602,
                        "lat": 23.172587
                    }
                }
            ]
        },
        {
            "citycode": "0756",
            "adcode": "440400",
            "name": "珠海",
            "center": {
                "lng": 113.576892,
                "lat": 22.271644
            },
            "districtList": [
                {
                    "citycode": "0756",
                    "adcode": "440402",
                    "name": "香洲区",
                    "center": {
                        "lng": 113.543372,
                        "lat": 22.265635
                    }
                },
                {
                    "citycode": "0756",
                    "adcode": "440403",
                    "name": "斗门区",
                    "center": {
                        "lng": 113.296228,
                        "lat": 22.209134
                    }
                },
                {
                    "citycode": "0756",
                    "adcode": "440404",
                    "name": "金湾区",
                    "center": {
                        "lng": 113.363224,
                        "lat": 22.146717
                    }
                },
                {
                    "citycode": [],
                    "adcode": "440499",
                    "name": "澳门大学横琴校区(由澳门实施管辖)",
                    "center": {
                        "lng": 113.548956,
                        "lat": 22.126197
                    }
                }
            ]
        },
        {
            "citycode": "0757",
            "adcode": "440600",
            "name": "佛山",
            "center": {
                "lng": 113.121586,
                "lat": 23.021351
            },
            "districtList": [
                {
                    "citycode": "0757",
                    "adcode": "440608",
                    "name": "高明区",
                    "center": {
                        "lng": 112.892573,
                        "lat": 22.900047
                    }
                },
                {
                    "citycode": "0757",
                    "adcode": "440607",
                    "name": "三水区",
                    "center": {
                        "lng": 112.897271,
                        "lat": 23.156675
                    }
                },
                {
                    "citycode": "0757",
                    "adcode": "440605",
                    "name": "南海区",
                    "center": {
                        "lng": 113.143246,
                        "lat": 23.028875
                    }
                },
                {
                    "citycode": "0757",
                    "adcode": "440604",
                    "name": "禅城区",
                    "center": {
                        "lng": 113.122532,
                        "lat": 23.009475
                    }
                },
                {
                    "citycode": "0757",
                    "adcode": "440606",
                    "name": "顺德区",
                    "center": {
                        "lng": 113.293197,
                        "lat": 22.805413
                    }
                }
            ]
        },
        {
            "citycode": "0754",
            "adcode": "440500",
            "name": "汕头",
            "center": {
                "lng": 116.681956,
                "lat": 23.354152
            },
            "districtList": [
                {
                    "citycode": "0754",
                    "adcode": "440515",
                    "name": "澄海区",
                    "center": {
                        "lng": 116.755945,
                        "lat": 23.466314
                    }
                },
                {
                    "citycode": "0754",
                    "adcode": "440523",
                    "name": "南澳县",
                    "center": {
                        "lng": 117.023482,
                        "lat": 23.421658
                    }
                },
                {
                    "citycode": "0754",
                    "adcode": "440512",
                    "name": "濠江区",
                    "center": {
                        "lng": 116.726701,
                        "lat": 23.286605
                    }
                },
                {
                    "citycode": "0754",
                    "adcode": "440507",
                    "name": "龙湖区",
                    "center": {
                        "lng": 116.716464,
                        "lat": 23.372211
                    }
                },
                {
                    "citycode": "0754",
                    "adcode": "440511",
                    "name": "金平区",
                    "center": {
                        "lng": 116.70341,
                        "lat": 23.365716
                    }
                },
                {
                    "citycode": "0754",
                    "adcode": "440514",
                    "name": "潮南区",
                    "center": {
                        "lng": 116.439105,
                        "lat": 23.239196
                    }
                },
                {
                    "citycode": "0754",
                    "adcode": "440513",
                    "name": "潮阳区",
                    "center": {
                        "lng": 116.601677,
                        "lat": 23.264923
                    }
                }
            ]
        },
        {
            "citycode": "0758",
            "adcode": "441200",
            "name": "肇庆",
            "center": {
                "lng": 112.465245,
                "lat": 23.047747
            },
            "districtList": [
                {
                    "citycode": "0758",
                    "adcode": "441224",
                    "name": "怀集县",
                    "center": {
                        "lng": 112.166908,
                        "lat": 23.920806
                    }
                },
                {
                    "citycode": "0758",
                    "adcode": "441284",
                    "name": "四会市",
                    "center": {
                        "lng": 112.734309,
                        "lat": 23.326991
                    }
                },
                {
                    "citycode": "0758",
                    "adcode": "441226",
                    "name": "德庆县",
                    "center": {
                        "lng": 111.785544,
                        "lat": 23.145035
                    }
                },
                {
                    "citycode": "0758",
                    "adcode": "441225",
                    "name": "封开县",
                    "center": {
                        "lng": 111.512177,
                        "lat": 23.423928
                    }
                },
                {
                    "citycode": "0758",
                    "adcode": "441223",
                    "name": "广宁县",
                    "center": {
                        "lng": 112.440694,
                        "lat": 23.634808
                    }
                },
                {
                    "citycode": "0758",
                    "adcode": "441202",
                    "name": "端州区",
                    "center": {
                        "lng": 112.485577,
                        "lat": 23.051847
                    }
                },
                {
                    "citycode": "0758",
                    "adcode": "441203",
                    "name": "鼎湖区",
                    "center": {
                        "lng": 112.56738,
                        "lat": 23.159062
                    }
                },
                {
                    "citycode": "0758",
                    "adcode": "441204",
                    "name": "高要区",
                    "center": {
                        "lng": 112.458055,
                        "lat": 23.02474
                    }
                }
            ]
        },
        {
            "citycode": "0759",
            "adcode": "440800",
            "name": "湛江",
            "center": {
                "lng": 110.357538,
                "lat": 21.270108
            },
            "districtList": [
                {
                    "citycode": "0759",
                    "adcode": "440883",
                    "name": "吴川市",
                    "center": {
                        "lng": 110.779361,
                        "lat": 21.440763
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440881",
                    "name": "廉江市",
                    "center": {
                        "lng": 110.286109,
                        "lat": 21.609988
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440811",
                    "name": "麻章区",
                    "center": {
                        "lng": 110.333833,
                        "lat": 21.26437
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440825",
                    "name": "徐闻县",
                    "center": {
                        "lng": 110.17595,
                        "lat": 20.325969
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440803",
                    "name": "霞山区",
                    "center": {
                        "lng": 110.397721,
                        "lat": 21.192463
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440804",
                    "name": "坡头区",
                    "center": {
                        "lng": 110.455192,
                        "lat": 21.244405
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440823",
                    "name": "遂溪县",
                    "center": {
                        "lng": 110.25043,
                        "lat": 21.378371
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440802",
                    "name": "赤坎区",
                    "center": {
                        "lng": 110.365592,
                        "lat": 21.265948
                    }
                },
                {
                    "citycode": "0759",
                    "adcode": "440882",
                    "name": "雷州市",
                    "center": {
                        "lng": 110.097011,
                        "lat": 20.914548
                    }
                }
            ]
        },
        {
            "citycode": "0750",
            "adcode": "440700",
            "name": "江门",
            "center": {
                "lng": 113.081548,
                "lat": 22.578948
            },
            "districtList": [
                {
                    "citycode": "0750",
                    "adcode": "440784",
                    "name": "鹤山市",
                    "center": {
                        "lng": 112.964203,
                        "lat": 22.765912
                    }
                },
                {
                    "citycode": "0750",
                    "adcode": "440781",
                    "name": "台山市",
                    "center": {
                        "lng": 112.793812,
                        "lat": 22.251947
                    }
                },
                {
                    "citycode": "0750",
                    "adcode": "440705",
                    "name": "新会区",
                    "center": {
                        "lng": 113.034454,
                        "lat": 22.458519
                    }
                },
                {
                    "citycode": "0750",
                    "adcode": "440704",
                    "name": "江海区",
                    "center": {
                        "lng": 113.111029,
                        "lat": 22.561301
                    }
                },
                {
                    "citycode": "0750",
                    "adcode": "440703",
                    "name": "蓬江区",
                    "center": {
                        "lng": 113.078914,
                        "lat": 22.595285
                    }
                },
                {
                    "citycode": "0750",
                    "adcode": "440783",
                    "name": "开平市",
                    "center": {
                        "lng": 112.698113,
                        "lat": 22.377378
                    }
                },
                {
                    "citycode": "0750",
                    "adcode": "440785",
                    "name": "恩平市",
                    "center": {
                        "lng": 112.304904,
                        "lat": 22.183743
                    }
                }
            ]
        },
        {
            "citycode": "0662",
            "adcode": "441700",
            "name": "阳江",
            "center": {
                "lng": 111.98343,
                "lat": 21.856853
            },
            "districtList": [
                {
                    "citycode": "0662",
                    "adcode": "441781",
                    "name": "阳春市",
                    "center": {
                        "lng": 111.791587,
                        "lat": 22.17041
                    }
                },
                {
                    "citycode": "0662",
                    "adcode": "441721",
                    "name": "阳西县",
                    "center": {
                        "lng": 111.617696,
                        "lat": 21.753935
                    }
                },
                {
                    "citycode": "0662",
                    "adcode": "441702",
                    "name": "江城区",
                    "center": {
                        "lng": 111.95486,
                        "lat": 21.862451
                    }
                },
                {
                    "citycode": "0662",
                    "adcode": "441704",
                    "name": "阳东区",
                    "center": {
                        "lng": 112.005586,
                        "lat": 21.869081
                    }
                }
            ]
        },
        {
            "citycode": "0668",
            "adcode": "440900",
            "name": "茂名",
            "center": {
                "lng": 110.925533,
                "lat": 21.662728
            },
            "districtList": [
                {
                    "citycode": "0668",
                    "adcode": "440982",
                    "name": "化州市",
                    "center": {
                        "lng": 110.639581,
                        "lat": 21.664483
                    }
                },
                {
                    "citycode": "0668",
                    "adcode": "440904",
                    "name": "电白区",
                    "center": {
                        "lng": 111.013368,
                        "lat": 21.513946
                    }
                },
                {
                    "citycode": "0668",
                    "adcode": "440983",
                    "name": "信宜市",
                    "center": {
                        "lng": 110.946866,
                        "lat": 22.354887
                    }
                },
                {
                    "citycode": "0668",
                    "adcode": "440981",
                    "name": "高州市",
                    "center": {
                        "lng": 110.853169,
                        "lat": 21.918017
                    }
                },
                {
                    "citycode": "0668",
                    "adcode": "440902",
                    "name": "茂南区",
                    "center": {
                        "lng": 110.918566,
                        "lat": 21.641661
                    }
                }
            ]
        },
        {
            "citycode": "0660",
            "adcode": "441500",
            "name": "汕尾",
            "center": {
                "lng": 115.375557,
                "lat": 22.787204
            },
            "districtList": [
                {
                    "citycode": "0660",
                    "adcode": "441523",
                    "name": "陆河县",
                    "center": {
                        "lng": 115.659978,
                        "lat": 23.301557
                    }
                },
                {
                    "citycode": "0660",
                    "adcode": "441502",
                    "name": "城区",
                    "center": {
                        "lng": 115.36522,
                        "lat": 22.779204
                    }
                },
                {
                    "citycode": "0660",
                    "adcode": "441581",
                    "name": "陆丰市",
                    "center": {
                        "lng": 115.652142,
                        "lat": 22.91874
                    }
                },
                {
                    "citycode": "0660",
                    "adcode": "441521",
                    "name": "海丰县",
                    "center": {
                        "lng": 115.322974,
                        "lat": 22.967212
                    }
                }
            ]
        },
        {
            "citycode": "0766",
            "adcode": "445300",
            "name": "云浮",
            "center": {
                "lng": 112.044524,
                "lat": 22.915163
            },
            "districtList": [
                {
                    "citycode": "0766",
                    "adcode": "445322",
                    "name": "郁南县",
                    "center": {
                        "lng": 111.535387,
                        "lat": 23.234561
                    }
                },
                {
                    "citycode": "0766",
                    "adcode": "445381",
                    "name": "罗定市",
                    "center": {
                        "lng": 111.569788,
                        "lat": 22.768345
                    }
                },
                {
                    "citycode": "0766",
                    "adcode": "445321",
                    "name": "新兴县",
                    "center": {
                        "lng": 112.225174,
                        "lat": 22.695915
                    }
                },
                {
                    "citycode": "0766",
                    "adcode": "445302",
                    "name": "云城区",
                    "center": {
                        "lng": 112.043945,
                        "lat": 22.92815
                    }
                },
                {
                    "citycode": "0766",
                    "adcode": "445303",
                    "name": "云安区",
                    "center": {
                        "lng": 112.002947,
                        "lat": 23.070334
                    }
                }
            ]
        },
        {
            "citycode": "0762",
            "adcode": "441600",
            "name": "河源",
            "center": {
                "lng": 114.700215,
                "lat": 23.744276
            },
            "districtList": [
                {
                    "citycode": "0762",
                    "adcode": "441623",
                    "name": "连平县",
                    "center": {
                        "lng": 114.488358,
                        "lat": 24.369552
                    }
                },
                {
                    "citycode": "0762",
                    "adcode": "441625",
                    "name": "东源县",
                    "center": {
                        "lng": 114.7466,
                        "lat": 23.790079
                    }
                },
                {
                    "citycode": "0762",
                    "adcode": "441602",
                    "name": "源城区",
                    "center": {
                        "lng": 114.703305,
                        "lat": 23.734055
                    }
                },
                {
                    "citycode": "0762",
                    "adcode": "441621",
                    "name": "紫金县",
                    "center": {
                        "lng": 115.183814,
                        "lat": 23.635597
                    }
                },
                {
                    "citycode": "0762",
                    "adcode": "441624",
                    "name": "和平县",
                    "center": {
                        "lng": 114.935634,
                        "lat": 24.469177
                    }
                },
                {
                    "citycode": "0762",
                    "adcode": "441622",
                    "name": "龙川县",
                    "center": {
                        "lng": 115.26002,
                        "lat": 24.100599
                    }
                }
            ]
        },
        {
            "citycode": "0768",
            "adcode": "445100",
            "name": "潮州",
            "center": {
                "lng": 116.621901,
                "lat": 23.657662
            },
            "districtList": [
                {
                    "citycode": "0768",
                    "adcode": "445122",
                    "name": "饶平县",
                    "center": {
                        "lng": 117.0045,
                        "lat": 23.663294
                    }
                },
                {
                    "citycode": "0768",
                    "adcode": "445103",
                    "name": "潮安区",
                    "center": {
                        "lng": 116.676971,
                        "lat": 23.463598
                    }
                },
                {
                    "citycode": "0768",
                    "adcode": "445102",
                    "name": "湘桥区",
                    "center": {
                        "lng": 116.628343,
                        "lat": 23.675104
                    }
                }
            ]
        },
        {
            "citycode": "0663",
            "adcode": "445200",
            "name": "揭阳",
            "center": {
                "lng": 116.372732,
                "lat": 23.550968
            },
            "districtList": [
                {
                    "citycode": "0663",
                    "adcode": "445224",
                    "name": "惠来县",
                    "center": {
                        "lng": 116.295038,
                        "lat": 23.033889
                    }
                },
                {
                    "citycode": "0663",
                    "adcode": "445203",
                    "name": "揭东区",
                    "center": {
                        "lng": 116.411928,
                        "lat": 23.567252
                    }
                },
                {
                    "citycode": "0663",
                    "adcode": "445202",
                    "name": "榕城区",
                    "center": {
                        "lng": 116.36714,
                        "lat": 23.525918
                    }
                },
                {
                    "citycode": "0663",
                    "adcode": "445222",
                    "name": "揭西县",
                    "center": {
                        "lng": 115.841742,
                        "lat": 23.431314
                    }
                },
                {
                    "citycode": "0663",
                    "adcode": "445281",
                    "name": "普宁市",
                    "center": {
                        "lng": 116.165646,
                        "lat": 23.297742
                    }
                }
            ]
        },
        {
            "citycode": "0751",
            "adcode": "440200",
            "name": "韶关",
            "center": {
                "lng": 113.597324,
                "lat": 24.810977
            },
            "districtList": [
                {
                    "citycode": "0751",
                    "adcode": "440204",
                    "name": "浈江区",
                    "center": {
                        "lng": 113.611077,
                        "lat": 24.804898
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440282",
                    "name": "南雄市",
                    "center": {
                        "lng": 114.31184,
                        "lat": 25.117653
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440224",
                    "name": "仁化县",
                    "center": {
                        "lng": 113.749175,
                        "lat": 25.085764
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440232",
                    "name": "乳源瑶族自治县",
                    "center": {
                        "lng": 113.275875,
                        "lat": 24.775856
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440222",
                    "name": "始兴县",
                    "center": {
                        "lng": 114.061998,
                        "lat": 24.953908
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440203",
                    "name": "武江区",
                    "center": {
                        "lng": 113.58792,
                        "lat": 24.7929
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440205",
                    "name": "曲江区",
                    "center": {
                        "lng": 113.604591,
                        "lat": 24.682826
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440229",
                    "name": "翁源县",
                    "center": {
                        "lng": 114.129986,
                        "lat": 24.350581
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440233",
                    "name": "新丰县",
                    "center": {
                        "lng": 114.206641,
                        "lat": 24.059909
                    }
                },
                {
                    "citycode": "0751",
                    "adcode": "440281",
                    "name": "乐昌市",
                    "center": {
                        "lng": 113.347669,
                        "lat": 25.129892
                    }
                }
            ]
        },
        {
            "citycode": "0763",
            "adcode": "441800",
            "name": "清远",
            "center": {
                "lng": 113.056098,
                "lat": 23.682064
            },
            "districtList": [
                {
                    "citycode": "0763",
                    "adcode": "441882",
                    "name": "连州市",
                    "center": {
                        "lng": 112.377255,
                        "lat": 24.780873
                    }
                },
                {
                    "citycode": "0763",
                    "adcode": "441826",
                    "name": "连南瑶族自治县",
                    "center": {
                        "lng": 112.287212,
                        "lat": 24.725953
                    }
                },
                {
                    "citycode": "0763",
                    "adcode": "441825",
                    "name": "连山壮族瑶族自治县",
                    "center": {
                        "lng": 112.093726,
                        "lat": 24.570553
                    }
                },
                {
                    "citycode": "0763",
                    "adcode": "441881",
                    "name": "英德市",
                    "center": {
                        "lng": 113.401827,
                        "lat": 24.20716
                    }
                },
                {
                    "citycode": "0763",
                    "adcode": "441823",
                    "name": "阳山县",
                    "center": {
                        "lng": 112.641199,
                        "lat": 24.465234
                    }
                },
                {
                    "citycode": "0763",
                    "adcode": "441821",
                    "name": "佛冈县",
                    "center": {
                        "lng": 113.531559,
                        "lat": 23.879455
                    }
                },
                {
                    "citycode": "0763",
                    "adcode": "441802",
                    "name": "清城区",
                    "center": {
                        "lng": 113.062612,
                        "lat": 23.697889
                    }
                },
                {
                    "citycode": "0763",
                    "adcode": "441803",
                    "name": "清新区",
                    "center": {
                        "lng": 113.017747,
                        "lat": 23.734677
                    }
                }
            ]
        },
        {
            "citycode": "0760",
            "adcode": "442000",
            "name": "中山",
            "center": {
                "lng": 113.392517,
                "lat": 22.517024
            },
            "districtList": [
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "横栏镇",
                    "center": {
                        "lng": 113.22363,
                        "lat": 22.604755
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "小榄镇",
                    "center": {
                        "lng": 113.320629,
                        "lat": 22.560691
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "神湾镇",
                    "center": {
                        "lng": 113.376318,
                        "lat": 22.276818
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "古镇镇",
                    "center": {
                        "lng": 113.221289,
                        "lat": 22.609652
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "港口镇",
                    "center": {
                        "lng": 113.354019,
                        "lat": 22.602694
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "三乡镇",
                    "center": {
                        "lng": 113.431869,
                        "lat": 22.387876
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "石岐街道",
                    "center": {
                        "lng": 113.40412,
                        "lat": 22.548351
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "大涌镇",
                    "center": {
                        "lng": 113.296691,
                        "lat": 22.483379
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "阜沙镇",
                    "center": {
                        "lng": 113.340305,
                        "lat": 22.640609
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "西区街道",
                    "center": {
                        "lng": 113.314421,
                        "lat": 22.564923
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "沙溪镇",
                    "center": {
                        "lng": 113.343971,
                        "lat": 22.524791
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "东凤镇",
                    "center": {
                        "lng": 113.307919,
                        "lat": 22.680266
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "坦洲镇",
                    "center": {
                        "lng": 113.395777,
                        "lat": 22.312037
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "三角镇",
                    "center": {
                        "lng": 113.400593,
                        "lat": 22.640197
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "民众街道",
                    "center": {
                        "lng": 113.472738,
                        "lat": 22.653889
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "南头镇",
                    "center": {
                        "lng": 113.299916,
                        "lat": 22.683684
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "黄圃镇",
                    "center": {
                        "lng": 113.359373,
                        "lat": 22.681261
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "东区街道",
                    "center": {
                        "lng": 113.436188,
                        "lat": 22.514086
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "南区街道",
                    "center": {
                        "lng": 113.367676,
                        "lat": 22.488858
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "中山港街道",
                    "center": {
                        "lng": 113.418677,
                        "lat": 22.549913
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "板芙镇",
                    "center": {
                        "lng": 113.368695,
                        "lat": 22.406764
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "五桂山街道",
                    "center": {
                        "lng": 113.476817,
                        "lat": 22.428448
                    }
                },
                {
                    "citycode": "0760",
                    "adcode": "442000",
                    "name": "南朗街道",
                    "center": {
                        "lng": 113.486698,
                        "lat": 22.52574
                    }
                }
            ]
        },
        {
            "citycode": "0753",
            "adcode": "441400",
            "name": "梅州",
            "center": {
                "lng": 116.122046,
                "lat": 24.288832
            },
            "districtList": [
                {
                    "citycode": "0753",
                    "adcode": "441426",
                    "name": "平远县",
                    "center": {
                        "lng": 115.891235,
                        "lat": 24.566928
                    }
                },
                {
                    "citycode": "0753",
                    "adcode": "441481",
                    "name": "兴宁市",
                    "center": {
                        "lng": 115.731133,
                        "lat": 24.137296
                    }
                },
                {
                    "citycode": "0753",
                    "adcode": "441427",
                    "name": "蕉岭县",
                    "center": {
                        "lng": 116.171477,
                        "lat": 24.658963
                    }
                },
                {
                    "citycode": "0753",
                    "adcode": "441422",
                    "name": "大埔县",
                    "center": {
                        "lng": 116.694825,
                        "lat": 24.347037
                    }
                },
                {
                    "citycode": "0753",
                    "adcode": "441424",
                    "name": "五华县",
                    "center": {
                        "lng": 115.775751,
                        "lat": 23.932568
                    }
                },
                {
                    "citycode": "0753",
                    "adcode": "441403",
                    "name": "梅县区",
                    "center": {
                        "lng": 116.081395,
                        "lat": 24.266191
                    }
                },
                {
                    "citycode": "0753",
                    "adcode": "441402",
                    "name": "梅江区",
                    "center": {
                        "lng": 116.116686,
                        "lat": 24.31065
                    }
                },
                {
                    "citycode": "0753",
                    "adcode": "441423",
                    "name": "丰顺县",
                    "center": {
                        "lng": 116.181895,
                        "lat": 23.739364
                    }
                }
            ]
        }
    ]
}

export default city;


// WEBPACK FOOTER //
// ./src/util/province/guangdong.js